<template>
  <span class="text-sta-rouge text-sm font-bold">* (required)</span>
</template>
